import posthog from 'posthog-js';

// Common event tracking functions
export const trackEvent = (eventName, properties = {}) => {
  if (typeof posthog !== 'undefined') {
    posthog.capture(eventName, properties);
  }
};

// Specific event tracking functions
export const trackButtonClick = (buttonName, location) => {
  trackEvent('button_clicked', { button_name: buttonName, location });
};

export const trackDemoRequest = (formData) => {
  // Strip sensitive information if needed
  const safeData = { ...formData };
  delete safeData.message; // Don't track the free-form message
  
  trackEvent('demo_requested', safeData);
};

export const trackFeatureInteraction = (featureName) => {
  trackEvent('feature_interaction', { feature_name: featureName });
};

export const identifyUser = (email, properties = {}) => {
  if (typeof posthog !== 'undefined' && email) {
    posthog.identify(email, properties);
  }
};

// Create a named variable for the default export
const analytics = {
  trackEvent,
  trackButtonClick,
  trackDemoRequest,
  trackFeatureInteraction,
  identifyUser,
};

export default analytics;